import { APP_INITIALIZER, enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app/app.component';
import { AppRoutes } from './app/app-routing.module';

// Resolvers
import { BillingProductResolver } from './app/pages/billing/billing-product-resolver';
import { SeoLimitsResolver } from './app/pages/seo/seo-limit-resolver';
import { ProjectResolver } from './app/common/resolver/project-resolver';

// Services
import { ConsoleLoggerService, InterceptorService, LoggerService } from './app/common';
import { SeoInterceptorService } from './app/common/services/seo-interceptor.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppBreadcrumbService, MenuService } from './app/components';
import { PermissionMatrixStore } from './app/common/services/permission-matrix.store';

if (environment.production) {
    enableProdMode();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function preloadPermissionMatrixFactory(matrixStore: PermissionMatrixStore) {
  return () => matrixStore.preloadCurrentOrg();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(AppRoutes),
    importProvidersFrom(
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, { scrollPositionRestoration: 'enabled' }),
        TranslateModule.forRoot({
            loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] }
        })
        // add other module imports that expose providers if needed
    ),
    BillingProductResolver,
    SeoLimitsResolver,
    ProjectResolver,
    MessageService,
    AppBreadcrumbService,
    ConfirmationService,
    MenuService,
    { provide: LoggerService, useClass: ConsoleLoggerService },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SeoInterceptorService, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: preloadPermissionMatrixFactory,
      deps: [PermissionMatrixStore],
      multi: true
    }
  ]
});
